module.exports = __webpack_public_path__ + "static/media/ArrowLeft.51d35a75.svg";